import { MacroRegion } from "enum/MacroRegion";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { getMacroRegionOriginFromPolygon } from "util/macroRegion/getMacroRegionOriginFromPolygon";
import { useStores } from "../../../stores/setup/use-store";
import { extractCoordinatesFromGeoJSON } from "../../ForecastChart/ForecastChartPanelMap/util/extractCoordinatesFromGeoJSON";
import { ILocationFormValues } from "../types/";

export function useLocationGeospatial() {
	const {
		dataStores: { forecastChartPageStore, locationStore, regionStore, authStore, insightAlertStore },
	} = useStores();

	const history = useHistory();

	const handleDrawingMode = useCallback((formValues?: ILocationFormValues) => {
		forecastChartPageStore.setIsAreaDrawingMode(true);

		if (formValues) {
			locationStore.setCreateFormValues(formValues);
		}

		let existingCoordinates = locationStore.selectedLocation?.coordinates || [];
		if (existingCoordinates.length) {
			locationStore.setSelectedCoordinates(existingCoordinates);
		}

		const locationId = locationStore.selectedLocation?.id;
		if (locationId && locationStore.isEditing) {
			history.push(`/forecast-charts?location_id=${locationId}`);
		} else if (locationStore.isEditing && !locationId) {
			console.warn('Editing mode but no selectedLocation.id found');
			history.push(`/forecast-charts?location_id=new`);
		} else {
			history.push(`/forecast-charts?location_id=new`);
		}
	}, [forecastChartPageStore, history, locationStore]);

	const handleGeoJsonLoaded = useCallback((geojson: any) => {
		if (!geojson) return;

		locationStore.setIsGeofenceLoadedByGeoJson(true);

		const coordinates = extractCoordinatesFromGeoJSON(geojson);
		const macroRegion = getMacroRegionOriginFromPolygon(
			coordinates,
			regionStore.macroRegions,
			authStore.userMarcroRegions as MacroRegion[]
		);

		locationStore.setSelectedCoordinates(coordinates);

		if (macroRegion) {
			insightAlertStore.setIsGeofenceInvalid(false);
		} else {
			insightAlertStore.setIsGeofenceInvalid(true);
		}
	}, [authStore.userMarcroRegions, insightAlertStore, locationStore, regionStore.macroRegions]);

	const clearGeofence = useCallback(() => {
		locationStore.setSelectedCoordinates([]);
		locationStore.setIsGeofenceLoadedByGeoJson(false);
		insightAlertStore.setIsGeofenceInvalid(false);
	}, [locationStore]);

	const exitDrawingMode = useCallback(() => {
		forecastChartPageStore.setIsAreaDrawingMode(false);
	}, [forecastChartPageStore]);

	const setIsGeofenceLoadedByGeoJson = useCallback((value: boolean) => {
		locationStore.setIsGeofenceLoadedByGeoJson(value);
	}, [locationStore]);

	return {
		handleDrawingMode,
		handleGeoJsonLoaded,
		clearGeofence,
		exitDrawingMode,
		selectedGeofence: locationStore.selectedCoordinates,
		isAreaDrawingMode: forecastChartPageStore.isAreaDrawingMode,
		setIsGeofenceLoadedByGeoJson,
	};
}